(function () {
  function initBundleBlock(block) {
    if (!block || block.getAttribute('data-bly-bundle-ready') === 'true') {
      return;
    }

    block.setAttribute('data-bly-bundle-ready', 'true');

    const form = block.closest('form');
    if (!form) return;

    let quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.appendChild(quantityInput);
    }

    const options = Array.from(block.querySelectorAll('.BlyBundleOption'));
    if (!options.length) {
      return;
    }

    const optionData = new Map();
    const perks = block.querySelector('.BlyBundleBlock__perks');
    const summary = block.querySelector('[data-bly-summary], .BlyBundleBlock__summary');
    const perkItems = perks
      ? {
          shipping: perks.querySelector('[data-perk="shipping"]'),
          guarantee: perks.querySelector('[data-perk="guarantee"]'),
          flexible: perks.querySelector('[data-perk="flexible"]')
        }
      : null;

    options.forEach((option, index) => {
      const qty = parseInt(option.getAttribute('data-bly-quantity'), 10);
      const discount = parseFloat(option.getAttribute('data-bly-discount'));
      const labelEl = option.querySelector('.BlyBundleOption__label');
      const subtextEl = option.querySelector('.BlyBundleOption__subtext');

      optionData.set(option, {
        index,
        qty: Number.isNaN(qty) ? 1 : qty,
        discount: Number.isNaN(discount) ? 0 : discount,
        priceEl: option.querySelector('.BlyBundleOption__price'),
        priceValueEl: option.querySelector('.BlyBundleOption__price-value'),
        discountPillEl: option.querySelector('.BlyBundleOption__discount-pill'),
        labelText: labelEl ? labelEl.textContent.trim() : '',
        subtextText: subtextEl ? subtextEl.textContent.trim() : ''
      });
    });

    const productContainer = block.closest('.Product') || document.querySelector('.Product');
    const productDataScript = form.querySelector('[data-product-json]');
    let productData = null;

    if (productDataScript && productDataScript.textContent) {
      try {
        productData = JSON.parse(productDataScript.textContent);
      } catch (error) {
        productData = null;
      }
    }

    const getVariantById = (variantId) => {
      if (!productData || !productData.product || !productData.product.variants) {
        return null;
      }

      return productData.product.variants.find((variant) => variant.id === variantId) || null;
    };

    const purchaseOptionElements = Array.from(block.querySelectorAll('[data-bly-purchase-option]'));
    const purchaseOptionsByType = new Map();

    purchaseOptionElements.forEach((option) => {
      const type = option.getAttribute('data-bly-purchase-type');
      if (!type) return;

      purchaseOptionsByType.set(type, {
        element: option,
        input: option.querySelector('input[type="radio"]')
      });
    });

    let currentVariant = productData ? getVariantById(productData.selected_variant_id) : null;
    let selectedPurchaseType =
      productData && productData.product && productData.product.selling_plan_groups && productData.product.selling_plan_groups.length
        ? 'subscription'
        : 'onetime';
    let selectedSellingPlanId = null;
    let isUpdatingButton = false;
    let buttonObserverAttached = false;
    let priceObserverAttached = false;
    let isUpdatingPriceList = false;
    let priceRecoveryTimer = null;

    const normalizePlanId = (value) => {
      const parsed = parseInt(value, 10);
      if (Number.isNaN(parsed) || parsed <= 0) return null;
      return parsed;
    };

    const normalizeIntervalText = (value) => {
      return String(value || '')
        .replace(/\b(every|delivers?|delivery|per|each)\b/gi, ' ')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    };

    const parseInterval = (value) => {
      if (!value) return null;

      const match = String(value).match(/(\d+(?:\.\d+)?)\s*(day|days|week|weeks|month|months|year|years)/i);
      if (!match) return null;

      const amount = parseFloat(match[1]);
      if (Number.isNaN(amount)) return null;

      return { amount, unit: match[2].toLowerCase() };
    };

    const intervalToDays = (interval) => {
      if (!interval || typeof interval.amount !== 'number') return null;
      if (interval.unit.startsWith('day')) return interval.amount;
      if (interval.unit.startsWith('week')) return interval.amount * 7;
      if (interval.unit.startsWith('month')) return interval.amount * 30;
      if (interval.unit.startsWith('year')) return interval.amount * 365;
      return null;
    };

    const allPlanOptions = (() => {
      if (!productData || !productData.product || !productData.product.selling_plan_groups) {
        return [];
      }

      let planIndex = 0;

      return productData.product.selling_plan_groups.reduce((result, group) => {
        (group.selling_plans || []).forEach((plan) => {
          const id = normalizePlanId(plan.id);
          if (!id) return;

          const optionValue = plan.options && plan.options[0] ? plan.options[0].value : '';
          const text = String(optionValue || plan.name || '').trim();
          const interval = parseInterval(text);

          result.push({
            id,
            text,
            interval,
            days: intervalToDays(interval),
            index: planIndex,
            groupId: group.id,
            groupName: group.name || '',
            plan
          });

          planIndex += 1;
        });

        return result;
      }, []);
    })();

    const getPlanById = (planId, variant = currentVariant) => {
      const normalizedPlanId = normalizePlanId(planId);
      if (!normalizedPlanId) return null;

      const availablePlan = getAvailablePlanOptions(variant).find((plan) => String(plan.id) === String(normalizedPlanId));
      if (availablePlan) return availablePlan;

      return allPlanOptions.find((plan) => String(plan.id) === String(normalizedPlanId)) || null;
    };

    const getAvailablePlanOptions = (variant = currentVariant) => {
      if (!variant) {
        return allPlanOptions.slice();
      }

      const allocationIds = new Set(
        (variant.selling_plan_allocations || []).map((allocation) => String(allocation.selling_plan_id))
      );
      if (!allocationIds.size) return [];

      return allPlanOptions.filter((plan) => allocationIds.has(String(plan.id)));
    };

    const getWidgetTargets = () =>
      Array.from(
        form.querySelectorAll(
          '.sealsubs-target-element[data-seal-extension], .sealsubs-target-element[data-seal-ac], .sealsubs-target-element[data-product-id], .sealsubs-target-element[data-handle]'
        )
      );

    const getCanonicalSellingPlanInput = () => {
      let input = form.querySelector('[data-bly-selling-plan-input]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-bly-selling-plan-input', 'true');
        form.appendChild(input);
      }

      return input;
    };

    const getCanonicalIntervalInput = () => {
      let input = form.querySelector('[data-bly-subs-interval-input]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'subs_interval';
        input.setAttribute('data-bly-subs-interval-input', 'true');
        form.appendChild(input);
      }

      return input;
    };

    const syncExternalPlanInputs = () => {
      const canonicalSellingPlanInput = getCanonicalSellingPlanInput();
      Array.from(form.querySelectorAll('input[name="selling_plan"]')).forEach((input) => {
        input.disabled = input !== canonicalSellingPlanInput;
      });

      const canonicalIntervalInput = getCanonicalIntervalInput();
      Array.from(form.querySelectorAll('input[name="subs_interval"]')).forEach((input) => {
        input.disabled = input !== canonicalIntervalInput;
      });
    };

    const getSellingPlanId = () => {
      if (selectedPurchaseType !== 'subscription') {
        return null;
      }

      const input = getCanonicalSellingPlanInput();

      if (input && input.value) {
        const parsed = normalizePlanId(input.value);
        if (parsed) return parsed;
      }

      return selectedSellingPlanId;
    };

    const getActivePurchaseType = () => selectedPurchaseType;

    const getOptionFrequency = (option) => {
      const data = optionData.get(option);
      const text = data ? data.subtextText || data.labelText : '';
      const interval = parseInterval(text);

      return {
        text,
        interval,
        days: intervalToDays(interval)
      };
    };

    const findPlanForOption = (option, variant = currentVariant) => {
      const planOptions = getAvailablePlanOptions(variant);
      if (!planOptions.length) return null;

      const frequency = getOptionFrequency(option);
      const normalizedTarget = normalizeIntervalText(frequency.text);
      const directMatch = planOptions.find((plan) => normalizeIntervalText(plan.text) === normalizedTarget);
      if (directMatch) return directMatch;

      if (frequency.days != null) {
        let closest = null;
        let closestDiff = Number.POSITIVE_INFINITY;

        planOptions.forEach((plan) => {
          if (plan.days == null) return;

          const diff = Math.abs(plan.days - frequency.days);
          if (diff < closestDiff) {
            closest = plan;
            closestDiff = diff;
          }
        });

        if (closest) return closest;
      }

      const fallbackIndex = optionData.get(option)?.index || 0;
      const sorted = planOptions.slice().sort((a, b) => {
        if (a.days == null || b.days == null) return a.index - b.index;
        return a.days - b.days;
      });
      const clampedIndex = Math.min(fallbackIndex, sorted.length - 1);

      return sorted[sorted.length - 1 - clampedIndex] || sorted[0];
    };

    const findOptionForPlan = (plan) => {
      if (!plan || !options.length) return null;

      const normalizedPlan = normalizeIntervalText(plan.text);
      let directMatch = null;

      options.forEach((option) => {
        const frequency = getOptionFrequency(option);
        if (normalizeIntervalText(frequency.text) === normalizedPlan) {
          directMatch = option;
        }
      });

      if (directMatch) return directMatch;

      if (plan.days != null) {
        let closest = null;
        let closestDiff = Number.POSITIVE_INFINITY;

        options.forEach((option) => {
          const frequency = getOptionFrequency(option);
          if (frequency.days == null) return;

          const diff = Math.abs(frequency.days - plan.days);
          if (diff < closestDiff) {
            closest = option;
            closestDiff = diff;
          }
        });

        if (closest) return closest;
      }

      return options[Math.min(plan.index || 0, options.length - 1)];
    };

    const updateOptionState = (activeOption) => {
      options.forEach((item) => {
        const isActive = item === activeOption;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-checked', isActive ? 'true' : 'false');
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');

        const input = item.querySelector('input[type="radio"]');
        if (input) input.checked = isActive;
      });
    };

    const updatePurchaseOptionState = (purchaseType) => {
      purchaseOptionsByType.forEach((control, type) => {
        const isActive = type === purchaseType;
        const isDisabled = control.input ? control.input.disabled : control.element.classList.contains('is-disabled');

        control.element.classList.toggle('is-active', isActive);
        control.element.classList.toggle('is-disabled', isDisabled);
        control.element.setAttribute('aria-checked', isActive ? 'true' : 'false');
        control.element.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

        if (control.input) {
          control.input.checked = isActive;
        }
      });
    };

    const setPurchaseOptionDisabled = (purchaseType, isDisabled) => {
      const control = purchaseOptionsByType.get(purchaseType);
      if (!control) return;

      control.element.classList.toggle('is-disabled', isDisabled);
      control.element.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

      if (control.input) {
        control.input.disabled = isDisabled;
      }
    };

    const updateSummary = (activeOption) => {
      if (!summary || !activeOption) return;

      const data = optionData.get(activeOption);
      if (!data) return;

      const parts = [];
      if (data.labelText) parts.push(data.labelText);
      if (data.subtextText) parts.push(data.subtextText);
      summary.textContent = parts.join(' ');
    };

    const setPlanInputs = (plan) => {
      syncExternalPlanInputs();

      const sellingPlanInput = getCanonicalSellingPlanInput();
      sellingPlanInput.value = plan && plan.id ? String(plan.id) : '';

      const intervalInput = getCanonicalIntervalInput();
      intervalInput.value = plan && plan.text ? plan.text : '';
    };

    const dispatchWidgetPlanChange = (planId) => {
      getWidgetTargets().forEach((target) => {
        target.dispatchEvent(
          new CustomEvent('sealsubs:change_selected_selling_plan_id', {
            detail: {
              selling_plan_id: planId ? String(planId) : '',
              sellingPlanId: planId ? String(planId) : '',
              selling_plan: planId ? String(planId) : ''
            },
            bubbles: true,
            composed: true
          })
        );
      });
    };

    const getActiveOption = () => {
      const active = block.querySelector('.BlyBundleOption.is-active') || options[0];
      if (active && optionData.has(active)) {
        return optionData.get(active);
      }

      const qtyFallback = parseInt(quantityInput.value, 10);
      return {
        index: 0,
        qty: Number.isNaN(qtyFallback) ? 1 : qtyFallback,
        discount: 0,
        priceEl: null
      };
    };

    const setPerkState = (perk, isAvailable) => {
      if (!perk) return;
      perk.classList.toggle('is-unavailable', !isAvailable);
    };

    const setBundleState = (purchaseType) => {
      const isSubscription = purchaseType === 'subscription';
      block.classList.toggle('is-subscription', isSubscription);
      block.classList.toggle('is-onetime', !isSubscription);
    };

    const updatePerks = (activeOption, purchaseType) => {
      if (!perkItems) return;

      const activeIndex = activeOption && typeof activeOption.index === 'number' ? activeOption.index : 0;
      const hasFreeShipping = activeIndex <= 1;
      setPerkState(perkItems.shipping, hasFreeShipping);

      const hasSubscription = purchaseType === 'subscription';
      setPerkState(perkItems.guarantee, hasSubscription);

      if (perkItems.flexible) {
        const subscriptionText =
          perkItems.flexible.getAttribute('data-perk-subscription') || perkItems.flexible.textContent;
        const onetimeText =
          perkItems.flexible.getAttribute('data-perk-onetime') || perkItems.flexible.textContent;
        perkItems.flexible.textContent = hasSubscription ? subscriptionText : onetimeText;
        setPerkState(perkItems.flexible, hasSubscription);
      }
    };

    const formatMoney = (cents, format) => {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      const formatString = format || '${{amount}}';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = formatString.match(placeholderRegex);

      if (!match) {
        return (Number(cents) / 100).toFixed(2);
      }

      const defaultTo = (value, defaultValue) => (value == null || value !== value ? defaultValue : value);
      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return '0';
        }

        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? `${decimal}${parts[1]}` : '';

        return dollarsAmount + centsAmount;
      };

      let value = '';
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

      if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value).replace(',00', '');
      }

      return formatString.replace(placeholderRegex, value).replace('.00', '');
    };

    const stripHtml = (value) => value.replace(/<[^>]*>/g, '');

    const getSubscriptionBasePrice = (variant, sellingPlanId) => {
      if (!variant) return null;
      if (!sellingPlanId) return variant.price;

      const allocations = variant.selling_plan_allocations || [];
      const allocation = allocations.find((item) => String(item.selling_plan_id) === String(sellingPlanId));
      const allocationPrice = allocation ? allocation.price || allocation.per_delivery_price : null;
      if (typeof allocationPrice === 'number') return allocationPrice;

      return variant.price;
    };

    const getDiscountedUnitPrice = (variant, sellingPlanId, discount) => {
      const basePrice = getSubscriptionBasePrice(variant, sellingPlanId);
      if (basePrice === null || typeof basePrice === 'undefined') return null;
      return Math.round((basePrice * (100 - discount)) / 100);
    };

    const getDiscountPercent = (compareAtPrice, unitPrice) => {
      if (!compareAtPrice || compareAtPrice <= 0 || unitPrice === null || typeof unitPrice === 'undefined') {
        return 0;
      }

      if (compareAtPrice <= unitPrice) return 0;
      return Math.round(((compareAtPrice - unitPrice) * 100) / compareAtPrice);
    };

    const updateOptionPrices = (variant, sellingPlanId) => {
      if (!variant) return;

      optionData.forEach((data, option) => {
        if (!data.priceEl && !data.priceValueEl) return;

        const planForOption = sellingPlanId ? findPlanForOption(option) : null;
        const planId = planForOption && planForOption.id ? planForOption.id : sellingPlanId;
        const unitPrice = getDiscountedUnitPrice(variant, planId, data.discount);
        if (unitPrice === null) return;

        if (data.discountPillEl) {
          const compareAt = variant.compare_at_price || 0;
          const salePercent = getDiscountPercent(compareAt, unitPrice);
          data.discountPillEl.textContent = `${salePercent}%`;
        }

        if (data.priceValueEl) {
          data.priceValueEl.textContent = formatMoney(unitPrice, window.theme.moneyFormat);
          return;
        }

        data.priceEl.textContent = `${formatMoney(unitPrice, window.theme.moneyFormat)}/Each`;
      });
    };

    const updatePriceList = (variant, sellingPlanId, activeOption) => {
      if (!productContainer || !variant) return;

      const priceList = productContainer.querySelector('.ProductMeta__PriceList');
      if (!priceList) return;

      const unitPrice = getDiscountedUnitPrice(variant, sellingPlanId, activeOption.discount);
      if (unitPrice === null) return;

      const compareAt = variant.compare_at_price || 0;
      const currencyFormat = window.theme.currencyCodeEnabled
        ? window.theme.moneyWithCurrencyFormat
        : window.theme.moneyFormat;
      const showCompareAt = compareAt > unitPrice;
      const salePercent = showCompareAt ? Math.round(((compareAt - unitPrice) * 100) / compareAt) : 0;
      const saleBadgeMarkup =
        showCompareAt && salePercent > 0
          ? `<span class="badge badge--sale"><span>Save ${salePercent}%</span></span>`
          : '';

      let priceMarkup = '';
      if (showCompareAt) {
        priceMarkup = `<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>${formatMoney(unitPrice, currencyFormat)}</span>
<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>${formatMoney(compareAt, currencyFormat)}</span>`;
      } else {
        priceMarkup = `<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>${formatMoney(unitPrice, currencyFormat)}</span>`;
      }

      isUpdatingPriceList = true;
      priceList.innerHTML = `${priceMarkup}${saleBadgeMarkup}`;
      priceList.style.display = '';
      window.setTimeout(() => {
        isUpdatingPriceList = false;
      }, 0);
    };

    const updateAddToCart = (variant, sellingPlanId, activeOption) => {
      if (!productContainer || !variant) return;

      const addToCartButton = productContainer.querySelector('.ProductForm__AddToCart');
      if (!addToCartButton || !variant.available) return;

      if (addToCartButton.getAttribute('data-show-price-in-button') === 'false') {
        addToCartButton.innerHTML = `<span>${window.languages.productFormAddToCart}</span>`;
        return;
      }

      const unitPrice = getDiscountedUnitPrice(variant, sellingPlanId, activeOption.discount);
      if (unitPrice === null) return;

      const totalPrice = Math.round(unitPrice * activeOption.qty);
      const totalPriceLabel = stripHtml(formatMoney(totalPrice, window.theme.moneyFormat));
      const compareAtUnit = variant.compare_at_price || 0;
      const totalCompareAt = compareAtUnit ? Math.round(compareAtUnit * activeOption.qty) : 0;
      const showCompareAt = totalCompareAt > totalPrice;
      const compareAtLabel = stripHtml(formatMoney(totalCompareAt, window.theme.moneyFormat));
      const compareMarkup = showCompareAt
        ? `<span class="ProductForm__AddToCartCompare" data-bly-price="${compareAtLabel}" aria-hidden="true"></span><span class="u-visually-hidden">${compareAtLabel}</span>`
        : '';

      isUpdatingButton = true;
      addToCartButton.innerHTML = `<span>${window.languages.productFormAddToCart}</span>
<span class="Button__SeparatorDot"></span>
<span class="ProductForm__AddToCartPrice" data-bly-price="${totalPriceLabel}" aria-hidden="true"></span><span class="u-visually-hidden">${totalPriceLabel}</span>
${compareMarkup}`;

      window.setTimeout(() => {
        isUpdatingButton = false;
      }, 150);
    };

    const attachButtonObserver = () => {
      if (!productContainer || buttonObserverAttached || !('MutationObserver' in window)) return;

      const addToCartButton = productContainer.querySelector('.ProductForm__AddToCart');
      if (!addToCartButton) return;

      const buttonObserver = new MutationObserver(() => {
        if (isUpdatingButton) return;
        schedulePricingUpdate();
      });

      buttonObserver.observe(addToCartButton, { childList: true, subtree: true });
      buttonObserverAttached = true;
    };

    const attachPriceObserver = () => {
      if (!productContainer || priceObserverAttached || !('MutationObserver' in window)) return;

      const priceList = productContainer.querySelector('.ProductMeta__PriceList');
      if (!priceList) return;

      const recoverPrice = () => {
        if (priceRecoveryTimer) {
          window.clearTimeout(priceRecoveryTimer);
        }

        priceRecoveryTimer = window.setTimeout(() => {
          if (isUpdatingPriceList) return;
          updatePricing();
        }, 0);
      };

      const priceObserver = new MutationObserver(() => {
        if (isUpdatingPriceList) return;
        recoverPrice();
      });

      priceObserver.observe(priceList, {
        childList: true,
        subtree: true,
        characterData: true
      });

      priceObserverAttached = true;
    };

    const updatePricing = () => {
      const activeOption = getActiveOption();
      const purchaseType = getActivePurchaseType();
      const sellingPlanId = purchaseType === 'subscription' ? getSellingPlanId() : null;

      setBundleState(purchaseType);
      updatePurchaseOptionState(purchaseType);
      updatePerks(activeOption, purchaseType);

      if (!currentVariant) {
        const variantInput = form.querySelector('[name="id"]');
        const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
        if (variantId) {
          currentVariant = getVariantById(variantId);
        }
      }

      if (!currentVariant) return;

      updateOptionPrices(currentVariant, sellingPlanId);
      updatePriceList(currentVariant, sellingPlanId, activeOption);
      updateAddToCart(currentVariant, sellingPlanId, activeOption);
    };

    const schedulePricingUpdate = () => {
      window.setTimeout(updatePricing, 50);
    };

    const syncPurchaseAvailability = ({ syncWidget = false } = {}) => {
      const hasSubscriptionPlans = getAvailablePlanOptions().length > 0;
      const requiresSellingPlan = Boolean(productData && productData.product && productData.product.requires_selling_plan);

      setPurchaseOptionDisabled('subscription', !hasSubscriptionPlans);
      setPurchaseOptionDisabled('onetime', requiresSellingPlan);

      if (selectedPurchaseType === 'subscription' && !hasSubscriptionPlans) {
        selectedPurchaseType = 'onetime';
        selectedSellingPlanId = null;
        setPlanInputs(null);

        if (syncWidget) {
          dispatchWidgetPlanChange(null);
        }
      }

      if (requiresSellingPlan && hasSubscriptionPlans && selectedPurchaseType !== 'subscription') {
        selectedPurchaseType = 'subscription';
      }

      updatePurchaseOptionState(selectedPurchaseType);
    };

    const applyOptionSelection = (option) => {
      if (!option) return;

      updateOptionState(option);

      const qty = option.getAttribute('data-bly-quantity');
      if (qty) {
        quantityInput.value = qty;
      }

      updateSummary(option);
    };

    const syncOptionFromPlanId = (planId) => {
      const plan = getPlanById(planId);
      if (!plan) return null;

      const matchingOption = findOptionForPlan(plan);
      if (matchingOption) {
        applyOptionSelection(matchingOption);
      }

      return matchingOption;
    };

    const setPurchaseType = (purchaseType, { syncWidget = true, planId = null } = {}) => {
      const hasSubscriptionPlans = getAvailablePlanOptions().length > 0;
      const requiresSellingPlan = Boolean(productData && productData.product && productData.product.requires_selling_plan);

      if (purchaseType === 'subscription') {
        if (!hasSubscriptionPlans) return;
        selectedPurchaseType = 'subscription';

        const activeOption = block.querySelector('.BlyBundleOption.is-active') || options[0];
        const plan =
          getPlanById(planId) || findPlanForOption(activeOption) || getAvailablePlanOptions()[0] || null;

        if (plan) {
          selectedSellingPlanId = plan.id;
          setPlanInputs(plan);
        } else if (!requiresSellingPlan) {
          selectedPurchaseType = 'onetime';
          selectedSellingPlanId = null;
          setPlanInputs(null);
        }
      } else {
        if (requiresSellingPlan) return;

        selectedPurchaseType = 'onetime';
        selectedSellingPlanId = null;
        setPlanInputs(null);
      }

      updatePurchaseOptionState(selectedPurchaseType);
      schedulePricingUpdate();

      if (syncWidget) {
        dispatchWidgetPlanChange(selectedPurchaseType === 'subscription' ? selectedSellingPlanId : null);
      }
    };

    const setActive = (option, { syncWidget = true } = {}) => {
      if (!option) return;

      applyOptionSelection(option);

      if (selectedPurchaseType === 'subscription') {
        const plan = findPlanForOption(option) || getAvailablePlanOptions()[0] || null;

        if (plan) {
          selectedSellingPlanId = plan.id;
          setPlanInputs(plan);
        } else {
          selectedSellingPlanId = null;
          setPlanInputs(null);
        }

        if (syncWidget) {
          dispatchWidgetPlanChange(plan ? plan.id : null);
        }
      } else {
        selectedSellingPlanId = null;
        setPlanInputs(null);

        if (syncWidget) {
          dispatchWidgetPlanChange(null);
        }
      }

      schedulePricingUpdate();
    };

    options.forEach((option) => {
      option.addEventListener('click', () => {
        setActive(option);
      });

      const input = option.querySelector('input[type="radio"]');
      if (input) {
        input.addEventListener('change', () => {
          setActive(option);
        });
      }
    });

    purchaseOptionsByType.forEach((control, purchaseType) => {
      if (!control.input) return;

      control.input.addEventListener('change', () => {
        if (control.input.disabled) return;

        setPurchaseType(purchaseType);
      });
    });

    if (productContainer) {
      productContainer.addEventListener('variant:changed', (event) => {
        if (event && event.detail && event.detail.variant) {
          currentVariant = getVariantById(event.detail.variant.id) || event.detail.variant;
        }

        syncExternalPlanInputs();
        syncPurchaseAvailability({ syncWidget: false });

        if (selectedPurchaseType === 'subscription') {
          const activeOption = block.querySelector('.BlyBundleOption.is-active') || options[0];
          const plan =
            getPlanById(selectedSellingPlanId) || findPlanForOption(activeOption) || getAvailablePlanOptions()[0] || null;

          if (plan) {
            selectedSellingPlanId = plan.id;
            setPlanInputs(plan);
            dispatchWidgetPlanChange(plan.id);
          } else if (!(productData && productData.product && productData.product.requires_selling_plan)) {
            selectedPurchaseType = 'onetime';
            selectedSellingPlanId = null;
            setPlanInputs(null);
            dispatchWidgetPlanChange(null);
          }
        }

        updatePurchaseOptionState(selectedPurchaseType);
        updatePricing();
      });
    }

    const eventBelongsToForm = (event) => {
      if (!event || !event.detail) return false;

      const element = event.detail.element;
      if (!element) {
        return getWidgetTargets().length > 0;
      }

      return form.contains(element) || getWidgetTargets().includes(element);
    };

    const handleSubscriptionEvent = (event) => {
      if (!eventBelongsToForm(event)) {
        return;
      }

      syncExternalPlanInputs();

      const planId =
        event && event.detail
          ? normalizePlanId(event.detail.selling_plan_id || event.detail.sellingPlanId || event.detail.selling_plan)
          : null;
      const plan = getPlanById(planId);

      if (event.type === 'sealsubs:subscription_widget_created') {
        dispatchWidgetPlanChange(selectedPurchaseType === 'subscription' ? getSellingPlanId() : null);
        return;
      }

      if (event.type !== 'sealsubs:selling_plan_changed') {
        return;
      }

      if (planId) {
        selectedPurchaseType = 'subscription';
        selectedSellingPlanId = planId;

        if (plan) {
          syncOptionFromPlanId(planId);
          setPlanInputs(plan);
        } else {
          setPlanInputs({ id: planId, text: '' });
        }
      } else if (!(productData && productData.product && productData.product.requires_selling_plan)) {
        selectedPurchaseType = 'onetime';
        selectedSellingPlanId = null;
        setPlanInputs(null);
      }

      updatePurchaseOptionState(selectedPurchaseType);
      schedulePricingUpdate();
    };

    document.addEventListener('sealsubs:subscription_widget_created', handleSubscriptionEvent);
    document.addEventListener('sealsubs:selling_plan_changed', handleSubscriptionEvent);

    syncExternalPlanInputs();

    const defaultOption =
      options.find((option) => option.getAttribute('data-bly-default') === 'true') ||
      options.find((option) => {
        const input = option.querySelector('input[type="radio"]');
        return input && input.defaultChecked;
      });

    const initialPlanId =
      normalizePlanId(getCanonicalSellingPlanInput().value) ||
      Array.from(form.querySelectorAll('input[name="selling_plan"]'))
        .map((input) => normalizePlanId(input.value))
        .find(Boolean) ||
      null;

    let selectedOption =
      (initialPlanId && syncOptionFromPlanId(initialPlanId)) ||
      defaultOption ||
      block.querySelector('.BlyBundleOption.is-active') ||
      block.querySelector('input[type="radio"]:checked')?.closest('.BlyBundleOption') ||
      options[0] ||
      null;

    if (selectedOption) {
      applyOptionSelection(selectedOption);
    }

    if (initialPlanId) {
      selectedPurchaseType = 'subscription';
      selectedSellingPlanId = initialPlanId;
    }

    syncPurchaseAvailability({ syncWidget: false });

    if (selectedPurchaseType === 'subscription') {
      const plan =
        getPlanById(selectedSellingPlanId) ||
        findPlanForOption(selectedOption) ||
        getAvailablePlanOptions()[0] ||
        null;

      if (plan) {
        selectedSellingPlanId = plan.id;
        setPlanInputs(plan);
        dispatchWidgetPlanChange(plan.id);
      } else if (!(productData && productData.product && productData.product.requires_selling_plan)) {
        selectedPurchaseType = 'onetime';
        selectedSellingPlanId = null;
        setPlanInputs(null);
        dispatchWidgetPlanChange(null);
      }
    } else {
      setPlanInputs(null);
      dispatchWidgetPlanChange(null);
    }

    updatePurchaseOptionState(selectedPurchaseType);
    updatePricing();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        attachButtonObserver();
        attachPriceObserver();
      });
    } else {
      attachButtonObserver();
      attachPriceObserver();
    }
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    Array.from(scope.querySelectorAll('.BlyBundleBlock[data-section-id]')).forEach(initBundleBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target || document);
  });
})();
